var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CModal,
    {
      attrs: { value: _setup.props.value, title: "Map Styles", size: "xl" },
      on: { closed: _setup.handleClose },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "d-flex justify-content-end" },
                [
                  _c(_setup.CButton, {
                    attrs: { text: "Cancel", variant: "secondary" },
                    on: { click: _setup.handleClose },
                  }),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "div",
        { staticClass: "search-filters mb-3" },
        [
          _c(_setup.CInput, {
            attrs: { label: "Search styles", placeholder: "Type to search..." },
            model: {
              value: _setup.searchInput,
              callback: function ($$v) {
                _setup.searchInput = $$v
              },
              expression: "searchInput",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "presets-content" },
        [
          !_setup.filteredPresets?.length
            ? _c(
                "div",
                { staticClass: "no-results" },
                [
                  _c("font-awesome-icon", {
                    staticClass: "no-results-icon",
                    attrs: { icon: ["fa-solid", "fa-search"] },
                  }),
                  _vm._v(" "),
                  _c("h4", [_vm._v("No styles found")]),
                  _vm._v(" "),
                  _c("p", [_vm._v("Try adjusting your search terms")]),
                ],
                1
              )
            : [
                _c(
                  "div",
                  { staticClass: "presets-grid" },
                  _vm._l(_setup.filteredPresets, function (preset, index) {
                    return _c(_setup.MapStyleThumbnail, {
                      key: index,
                      attrs: { preset: preset },
                      on: { select: _setup.handlePresetSelect },
                    })
                  }),
                  1
                ),
              ],
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }